<template>
  <div class="mb-3 form-check">
    <input
        type="checkbox"
        :name="id"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="form-check-input"
        :id="id">
    <label class="form-check-label" :for="id">{{ name }}</label>
  </div>
</template>
<script setup>
import {defineProps} from 'vue'
defineProps({
  id: String,
  name: String,
  modelValue: String,
  value: Boolean
})
</script>
